import { parseDateToString, ONE_DAY_IN_MS } from '@utils/helpers';
import { CHANGE_JOURNEY_PARAM_SUCCESS, SET_JOURNEY_PARAMS } from '@store/yourJourney/actions';

const initialState = () => ({
  fromDate: parseDateToString(new Date()),
  toDate: parseDateToString(new Date(new Date().getTime() + ONE_DAY_IN_MS)),
  spaDate: null,
  adults: null,
  children: null,
  spaAdults: null,
  promoRateCode: null,
  tableAdults: null,
  tableChildren: null,
  childAges: '{}',
  rooms: [],
});

export default (state = initialState(), action) => {
  const { paramName, value, params } = action;
  switch (action.type) {
    case CHANGE_JOURNEY_PARAM_SUCCESS: {
      return {
        ...state,
        [paramName]: value,
      };
    }
    case SET_JOURNEY_PARAMS: {
      return {
        ...state,
        ...params,
      };
    }
    default:
      return state;
  }
};
